import { useContext, useState } from "react";
import { useFormik } from "formik";
import Context from "../../../context";
import PageSection from "../Layout/PageSection";
import FormField from "../Input/FormField";
import Button from "../Input/Button";
import Dropdown from "../Input/Dropdown";
import * as Icon from "react-bootstrap-icons";
import axios from "axios";
import { API_URL, RENEW_RATE_PLAN_LIST } from "../../data/constants";

export default function RenewPlanPage() {
  const { contextState, setContextState } = useContext(Context);
  const [termLength, setTermLength] = useState(1);
  /*const [error, setError] = useState();
  const [message, setMessage] = useState();*/

  function validate(values) {
    const errors = {};
    if (!values.customerNumbers) errors.customerNumbers = "Required";
    if (!values.contactName) errors.contactName = "Required";
    if (!values.contactPhone) errors.contactPhone = "Required";
    if (!values.contactEmail) {
      errors.contactEmail = "Required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.contactEmail)
    ) {
      errors.contactEmail = "Invalid Email Address";
    }
    return errors;
  }

  const renewForm = useFormik({
    initialValues: {
      customerNumbers: "",
      term: 1,
      contactName: "",
      contactPhone: "",
      contactEmail: "",
    },
    validate,
    onSubmit: (values) => {
    /*  setError();
      setMessage();*/
      values.term = termLength;
      let tempNumbers = values.customerNumbers.split(";");
      axios
        .post(API_URL + "/Accounts/RenewRatePlan", {
          customerNumbers: tempNumbers,
          term: termLength,
          contactName: values.contactName,
          contactPhone: values.contactPhone,
          contactEmail: values.contactEmail,
        },
            {
              headers: {
                Authorization: localStorage.getItem("accessToken"),
              },
            })
        .then((res) => {
          let data = {
            type: "message",
            title: res.data.title,
            content: res.data.message,
          };
          setContextState({ ...contextState, modal: data });
          
         /* if (res.data.success === false) setError(res.data.message);
          else setMessage(res.data.message);*/
        })
        .catch((err) => {
          console.error(err);
        });
    },
  });

  return (
    <div className="individual-wrapper">
      <span
        className="page-back-link"
        onClick={() => {
          setContextState({ ...contextState, detailActivePage: "overview" });
        }}>
        <Icon.ChevronLeft className="page-back-link-icon" />{" "}
        <p className="page-back-link-text">Back</p>
      </span>
      <div className="individual-header">
        <h1>Renew Rate Plan</h1>
      </div>
      <form onSubmit={renewForm.handleSubmit}>
        <PageSection isForm>
          <h5 className="renew-body-header-text">
            Please fill out the following fields to indicate you are ready to
            renew.
          </h5>
          <p className="mb-4">
            We will review and send you back custom renewal pricing in less than
            24 business hours. Renewal pricing can be requested up to 90 days in
            advance of your current expiration date.
          </p>
          <div className="form-row">
            <div className="col-12">
              <FormField
                name="Customer Number(s)"
                field="customerNumbers"
                type="text"
                form={renewForm}
                helpText="Separate Customer Numbers with a semicolon. ( ; )"
              />
            </div>
          </div>
          <Dropdown
            text="Interested in specific term length?"
            data={RENEW_RATE_PLAN_LIST}
            setValue={setTermLength}
          />
          <div className="form-row">
            <div className="col-12 col-xl-4">
              <FormField
                name="Name of contact person for renewal"
                field="contactName"
                type="text"
                form={renewForm}
              />
            </div>
            <div className="col-12 col-lg-6 col-xl-4">
              <FormField
                name="Contact Phone"
                field="contactPhone"
                type="text"
                form={renewForm}
              />
            </div>
            <div className="col-12 col-lg-6 col-xl-4">
              <FormField
                name="Contact Email"
                field="contactEmail"
                type="text"
                form={renewForm}
              />
            </div>
          </div>
        </PageSection>
        {/*{error && <p>{error}</p>}
        {message && <p>{message}</p>}*/}
        <Button
          className="btn btn--green btn--bordered"
          text="Submit"
          type="submit"
        />
      </form>
    </div>
  );
}
